<template>
  <v-row>
      <v-col cols="12">
          <vuetify-table
            :headers="headers"
            :api-u-r-l="apiURL"
            :title="title"
            permisosEliminar="eliminar_cuenta_folios_distribuidor"
            permisosNuevoMovimiento="crear_movimiento_folios_distribuidor"
            permisosHistorial="consultar_historial_cuenta_distribuidor"
            :permisosMovimientosCorporativos="permisosMovimientosCorporativos"
          >
          </vuetify-table>
      </v-col>
  </v-row>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
    middleware: 'auth',
    metaInfo() {
        return { title: 'Plan Corporativo' };
    },
    components: {
        VuetifyTable,
    },
    data: () => ({
      headers: [
        {
          text: 'No. Cuenta',
          value: 'account_number',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Folios',
          value: 'folios',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          align: 'left',
          sortable: true,
        },
      ],
      name: '',
      permisosMovimientosCorporativos: [
        'realizar_conversion_licencia', 'realizar_revertir_licencia',
      ],
    }),
    computed: {
        apiURL() {
            return '/api/account';
        },
        title() {
        return 'Cuenta de Plan Corporativo';
        },
    },
    mounted() {
      if (!this.can('cambiar_estado_cuenta_distribuidor')) {
        this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
      }
      if (!this.can('eliminar_cuenta_folios_distribuidor') && !this.can('crear_movimiento_folios_distribuidor')
            && !this.can('consultar_historial_cuenta_distribuidor')) {
        this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
      }
    },
};
</script>

<style>

</style>
